

























import Vue from 'vue'
import moment from 'moment'
import { DatePeriod } from '@/model/DatePeriod'
import { DatePeriodEnum } from '@/types/enums'
import { GET_SELECTED_UI_LANGUAGE, SCHEDULING_GET_PARAMETERS } from '@/store/getter-types'
import { SCHEDULING_SET_PARAMETERS } from '@/store/action-types'

interface ComponentData {
  currentDate: string
  isButtonClick: boolean
}

export default Vue.extend({
  name: 'PeriodSelector',

  props: {
    periodType: {
      type: String as () => DatePeriodEnum,
      default: DatePeriodEnum.Month
    },
    yearPeriodScrollDate: Date
  },

  data (): ComponentData {
    return {
      currentDate: moment().format('YYYY-MM-DD'),
      isButtonClick: false
    }
  },

  computed: {
    buttonLabel (): string {

      let begin = moment(this.currentDate).startOf(DatePeriodEnum.Month)
      let end = moment(this.currentDate).endOf(DatePeriodEnum.Month)

      if (this.periodType === DatePeriodEnum.Year) {
        begin = moment(this.currentDate)
        end = moment(this.currentDate).endOf(DatePeriodEnum.Year)
      }

      if (this.periodType === DatePeriodEnum.Week) {
        begin = moment(this.currentDate).isoWeekday(1).startOf('isoWeek')
        end = moment(this.currentDate).isoWeekday(1).endOf('isoWeek')
      }

      if (this.periodType === DatePeriodEnum.WorkingWeek) {
        begin = moment(this.currentDate).isoWeekday(1).startOf('isoWeek')
        end = moment(this.currentDate).isoWeekday(1).endOf('isoWeek').subtract(2, 'days')
      }

      if (this.periodType === DatePeriodEnum.Day) {
        begin = moment(this.currentDate).startOf(DatePeriodEnum.Day)
        end = moment(this.currentDate).endOf(DatePeriodEnum.Day)
      }

      let beginStr, endStr

      const beginMonth = begin.format('MMM')
      const endMonth = end.format('MMM')

      if (beginMonth === endMonth) {
        beginStr = begin.format('DD')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      } else {
        beginStr = begin.locale(this.selectedLocale).format('DD MMM')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      }

      const yearStr = end.format('YYYY')

      if (this.periodType === DatePeriodEnum.Day) {
        beginStr = begin.locale(this.selectedLocale).format('DD MMMM')
        return `${beginStr} ${yearStr}`
      } else if (this.periodType === DatePeriodEnum.Year) {
        if(this.yearPeriodScrollDate){
          this.currentDate = moment(this.yearPeriodScrollDate).format('YYYY-MM-DD')
          begin = moment(this.yearPeriodScrollDate)
          beginStr = begin.locale(this.selectedLocale).format('MMMM')
          return `${beginStr} ${yearStr}`
        } else {
          beginStr = begin.locale(this.selectedLocale).format('MMMM')
          return `${beginStr} ${yearStr}`
        }
      } else {
        return `${beginStr} - ${endStr} ${yearStr}`
      }
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }

  },

  watch: {
    currentDate (newValue: string): void {

      if(this.$route.path === '/planning') {
        let data: any = this.getRouteData()

        data.currentDate = newValue
        data.currentPeriod = DatePeriod.createFromDateString(newValue, this.periodType)
        this.$router.push({ name: 'planning', query: { data: JSON.stringify(data) } })

        let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]
        schedulingData.currentDate = data.currentDate
        schedulingData.currentPeriod = data.currentPeriod
        this.$store.dispatch(SCHEDULING_SET_PARAMETERS, schedulingData)
      } else if(this.$route.path === '/absences') {
        let data: any = this.getRouteData()

        data.currentDate = newValue
        data.currentPeriod = DatePeriod.createFromDateString(newValue, this.periodType)
        this.$router.push({ name: 'absences', query: { data: JSON.stringify(data) } })

        let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]
        schedulingData.currentDate = data.currentDate
        schedulingData.currentPeriod = data.currentPeriod
        this.$store.dispatch(SCHEDULING_SET_PARAMETERS, data)
      }

      if (this.periodType !== DatePeriodEnum.Year) {
        this.$emit('periodSelected', DatePeriod.createFromDateString(newValue, this.periodType))
      }
    },

    periodType (newValue: DatePeriodEnum): void {
      this.$emit('periodSelected', DatePeriod.createFromDateString(this.currentDate, newValue))
      if(this.periodType === DatePeriodEnum.Year) {
        this.$emit('yearPeriodChangeDate', this.currentDate)
      }
    },
  },

  methods: {
    allowedDates (item: any): any {
      if (this.periodType === DatePeriodEnum.WorkingWeek) {
        if (moment(item).isoWeekday() !== 6 && moment(item).isoWeekday() !== 7) {
          return item
        }
      } else {
        return item
      }
    },

    onPrevButtonClick (): void {
      if (this.periodType === DatePeriodEnum.Day) {
        this.currentDate = moment(this.currentDate).subtract(1, 'day').format('YYYY-MM-DD')
      } else if (this.periodType === DatePeriodEnum.Week) {
        this.currentDate = moment(this.currentDate).isoWeekday(1).subtract(1, 'week').format('YYYY-MM-DD')
      } else if (this.periodType === DatePeriodEnum.WorkingWeek) {
        this.currentDate = moment(this.currentDate).isoWeekday(1).subtract(1, 'week').format('YYYY-MM-DD')
      } else  if (this.periodType === DatePeriodEnum.Year) {
        this.currentDate = moment(this.currentDate).startOf('month').subtract(1, 'month').format('YYYY-MM-DD')
        if(moment(this.currentDate, 'YYYY-MM-DD').format('YYYY') !== moment(this.yearPeriodScrollDate).format('YYYY')) {
          this.$emit('periodSelected', DatePeriod.createFromDateString(this.currentDate, this.periodType))
          setTimeout(() => { this.$emit('yearPeriodChangeDate', this.currentDate) }, 0)
        }
        this.$emit('yearPeriodChangeDate', this.currentDate)
      } else {
        this.currentDate = moment(this.currentDate).startOf('month').subtract(1, 'month').format('YYYY-MM-DD')
      }
    },

    onNextButtonClick (): void {
      if (this.periodType === DatePeriodEnum.Day) {
        this.currentDate = moment(this.currentDate).add(1, 'day').format('YYYY-MM-DD')
      } else if (this.periodType === DatePeriodEnum.Week) {
        this.currentDate = moment(this.currentDate).isoWeekday(1).add(1, 'week').format('YYYY-MM-DD')
      } else if (this.periodType === DatePeriodEnum.WorkingWeek) {
        this.currentDate = moment(this.currentDate).isoWeekday(1).add(1, 'week').format('YYYY-MM-DD')
      } else  if (this.periodType === DatePeriodEnum.Year) {
        this.currentDate = moment(this.currentDate).startOf('month').add(1, 'month').format('YYYY-MM-DD')
        if(moment(this.currentDate, 'YYYY-MM-DD').format('YYYY') !== moment(this.yearPeriodScrollDate).format('YYYY')) {
          this.$emit('periodSelected', DatePeriod.createFromDateString(this.currentDate, this.periodType))
          setTimeout(() => { this.$emit('yearPeriodChangeDate', this.currentDate) }, 0)
        }
        this.$emit('yearPeriodChangeDate', this.currentDate)
      } else {
        this.currentDate = moment(this.currentDate).startOf('month').add(1, 'month').format('YYYY-MM-DD')
      }
    },

    onDateChange (data: string): void {
      if (this.periodType === DatePeriodEnum.Year) {
        if(moment(data, 'YYYY-MM-DD').format('YYYY') !== moment(this.yearPeriodScrollDate).format('YYYY') && !this.isButtonClick) {
          this.$emit('yearPeriodChangeDate', data)
          this.$emit('periodSelected', DatePeriod.createFromDateString(data, this.periodType))
        } else {
          this.$emit('yearPeriodChangeDate', data)
        }
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()
      let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]

      if(this.$route.path === '/planning' || this.$route.path === '/absences') {
        if(data && data.currentDate && moment(data.currentDate).isValid()) {
          this.currentDate = data.currentDate
        } else if(schedulingData && schedulingData.data && schedulingData.data.currentDate && moment(schedulingData.data.currentDate).isValid()) {
          this.currentDate = schedulingData.data.currentDate
        } else {
          this.currentDate = moment().format('YYYY-MM-DD')
        }
      } else {
        this.currentDate = moment().format('YYYY-MM-DD')
      }
    }
  },

  created () {
    this.setDataFromRoute()
  }
})
